function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { BulkAction } from '../../BulkAction';
import { Checkbox } from '../../Checkbox';
import { Inputbox } from '../../Inputbox';
import { Pagination } from '../../Pagination';
import { Text } from '../../Text';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import { ListContext } from '../context';
import { ListSelectionTypes } from '../helper';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListTopBar(props) {
  const {
    paginationMetaData,
    onHeaderSelect,
    pageSelectCheckboxVariant,
    isPageSelectCheckboxChecked,
    topBarLeftSlot,
    topBarRightSlot,
    searchResultCount
  } = props;
  const {
    listSelectionType,
    listSearchInputProps,
    bulkActionMetaData,
    selectedList,
    isNoSearchResult = false
  } = useContext(ListContext);
  const {
    isMobile
  } = useIsMobile(640);
  const {
    handleSearch = () => {},
    searchValue,
    ...restProps
  } = listSearchInputProps;
  const _handleSelectAll = event => {
    onHeaderSelect(event.target.checked);
  };
  const [backdropStatus, setBackdropStatus] = useState(false);
  //TODO: Hot fix for positioning actionlist backdrop, remove this useEffect when it is fixed from actionList
  useEffect(() => {
    const handleDocumentClick = e => {
      if (isMobile) {
        const actionList = e.target.closest('.sib-action-list');
        if (actionList && actionList.nextElementSibling) {
          setBackdropStatus(true);
        } else {
          setBackdropStatus(false);
        }
      }
    };
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [isMobile]);
  const bulkActionContainerClass = classNames({
    [moduleStyles['sib-list__bulk-panel-container']]: true,
    [moduleStyles['sib-list__bulk-panel-container-backdrop']]: isMobile && backdropStatus
  });
  const listTopBarClasses = classNames({
    [moduleStyles['sib-list__topbar']]: true,
    [moduleStyles['sib-list__topbar-xs']]: isMobile
  });
  const listItemTopBarSearchClasses = classNames({
    [moduleStyles['sib-list__topbar-left--searchbar']]: true,
    [moduleStyles['sib-list__topbar-xs-left--searchbar']]: isMobile
  });
  const listItemTopBarPaginationClasses = classNames({
    [moduleStyles['sib-list__topbar-right--pagination']]: true,
    [moduleStyles['sib-list__topbar-xs-right--pagination']]: isMobile
  });
  const showBulkAction = selectedList.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: listTopBarClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__topbar-left']
  }, /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__topbar-left-selection']
  }, listSelectionType === ListSelectionTypes.MULTI_SELECTION ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__topbar-left--selectAll'],
    style: {
      visibility: isNoSearchResult ? 'hidden' : 'inherit'
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: '',
    ellipsis: true,
    identifier: "sibCheckbox_selectAll",
    variant: pageSelectCheckboxVariant,
    labelContainerStyle: {
      width: '16px'
    },
    checked: isPageSelectCheckboxChecked,
    onChange: event => _handleSelectAll(event),
    onKeyDown: event => {
      if (event.which === 13 || event.which === 32) {
        _handleSelectAll(event);
      }
    }
  })), showBulkAction && /*#__PURE__*/React.createElement("div", {
    className: bulkActionContainerClass
  }, /*#__PURE__*/React.createElement(BulkAction, bulkActionMetaData))) : '', /*#__PURE__*/React.createElement("div", {
    className: listItemTopBarSearchClasses
  }, /*#__PURE__*/React.createElement(Inputbox, _extends({
    inputType: "search",
    value: searchValue,
    placeholder: "search",
    onChange: event => {
      const searchedValue = event.target.value;
      handleSearch(searchedValue);
    }
  }, restProps)))), /*#__PURE__*/React.isValidElement(topBarLeftSlot) && /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__topbar-left--slots']
  }, topBarLeftSlot)), /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__topbar-right']
  }, /*#__PURE__*/React.isValidElement(topBarRightSlot) && /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__topbar-right--slots']
  }, topBarRightSlot), !searchValue ? paginationMetaData && /*#__PURE__*/React.createElement("div", {
    className: listItemTopBarPaginationClasses
  }, /*#__PURE__*/React.createElement(Pagination, paginationMetaData)) : /*#__PURE__*/React.createElement(Text, {
    fontFamily: "interactive",
    size: "md",
    color: "var(--sib-color_content-secondary)"
  }, `${searchResultCount} results`)));
}
ListTopBar.defaultProps = {
  paginationMetaData: null,
  onHeaderSelect: () => {},
  pageSelectCheckboxVariant: '',
  isPageSelectCheckboxChecked: false,
  topBarLeftSlot: /*#__PURE__*/React.createElement(React.Fragment, null),
  topBarRightSlot: /*#__PURE__*/React.createElement(React.Fragment, null),
  searchResultCount: 0
};
ListTopBar.propTypes = {
  paginationMetaData: PropTypes.object,
  onHeaderSelect: PropTypes.func,
  pageSelectCheckboxVariant: PropTypes.string,
  isPageSelectCheckboxChecked: PropTypes.bool,
  topBarLeftSlot: PropTypes.node,
  topBarRightSlot: PropTypes.node,
  searchResultCount: PropTypes.number
};
export default ListTopBar;